<template>
  <div>
    <v-container>
      <v-row dense>
        <v-col cols="12" sm="4">
          <span class="caption font-weight-bold">Forma pagamento</span>
          <div>
            <px-forma-pagamento v-if="cotacao.formaPagamento"
                                :forma-pagamento="cotacao.formaPagamento"
                                :prazo-pagamento="cotacao.prazoPagamento"/>
            <span v-else>Não informado</span>
          </div>
        </v-col>
        <v-col cols="12" sm="4">
          <span class="caption font-weight-bold">Tipo de frete</span>
          <div>
            {{ cotacao.tipoFrete | naoInformado }}
          </div>
        </v-col>
        <v-col cols="12" sm="4">
          <span class="caption font-weight-bold">Entregar até</span>
          <div>
            {{ cotacao.prazoEntrega | date | naoInformado }}
          </div>
        </v-col>
      </v-row>
      <v-row dense class="mt-3">
        <v-col cols="12" sm="4">
          <span class="caption font-weight-bold">Valido até</span>
          <div>
            {{ cotacao.validade | date | naoInformado }}
          </div>
        </v-col>
        <v-col cols="12" sm="4">
          <span class="caption font-weight-bold">Observação</span>
          <div>
            <px-show-large-text :large-text="cotacao.observacao"/>
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-3">
        <v-col cols="12">
          <px-resposta-card-cotacao-detalhes-produtos :produtos="produtos"/>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { SituacoesCotacao } from 'px-business-components';
import RespostaCardCotacaoDetalhesProdutos from './RespostaCardCotacaoDetalhesProdutos.vue';

export default {
  props: {
    cotacao: Object,
  },
  data() {
    return {
      produtos: [],
    };
  },
  components: {
    pxRespostaCardCotacaoDetalhesProdutos: RespostaCardCotacaoDetalhesProdutos,
  },
  created() {
    this.produtos = this.cotacao.produtos
      .filter(produto => SituacoesCotacao.ABERTAS.includes(produto.situacao));
  },
};
</script>
